import {useNativeInfo} from 'hooks'
import {PoliciesLeftNavigation} from './PoliciesNavigation'
import {SettingsLeftNavigation} from './SettingsNavigation'

export function LeftNavigation() {
  const {pathname} = useNativeInfo()

  if (pathname.includes('/settings')) return <SettingsLeftNavigation />
  //shoow left nav if route is  /policies/**, hide if route is exactly /policies/
  else if (pathname.includes('/policies/') && pathname !== '/policies/')
    return <PoliciesLeftNavigation />
  return null
}
